import React from 'react';

// import { AboutUs, Chef, FindUs, Footer, Gallery, Header, Intro, Laurels, SpecialMenu } from './container';
// import { Navbar } from './components';
import './App.css';
import './index.css';
import { Navbar } from './components/Navbar/Navbar';
import { Header, Header2, Header3, Header4 } from './container/Header/Header';
import { AboutUs } from './container/AboutUs/AboutUs';
import { SpecialMenu } from './container/Menu/SpecialMenu';
import { Chef, Chef2 } from './container/Chef/Chef';
import { Intro } from './container/Intro/Intro';
import { Gallery } from './container/Gallery/Gallery';
import { FindUs } from './container/Findus/FindUs';
import { Footer } from './container/Footer/Footer';
import { Laurels } from './container/Laurels/Laurels';
import { Services } from './container/Services/Services';
import { Route, Routes } from 'react-router-dom';
import { PackagesV2 } from './container/Packages/Packages';
import { TransfersMain } from './container/Transfers/Transfers';
import { HOME_ROUTE } from '../../../../routing/routing_constants';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Backdrop } from '@mui/material';
import { Spinner } from '../../../sharable_components/small_components/alerts/loading';

export const RoutingV2 = () => {
  const dispatch = useDispatch()
  const loading = useSelector(state=>state.loading_state)

  const short_alert = useSelector(state => state.short_alert)
 

  return(
      <div>
        <Navbar />
        {short_alert && <ErrorSuccessSweetAlert message={short_alert.message} type={short_alert.alert_type}/>}
        {loading && <Backdrop ><Spinner /></Backdrop>}
            <Routes>
              <Route path='home' element={<HomeV2 />} />
              <Route path='packages' element={<PackagesV2 />} />
              <Route path='transfers' element={<TransfersMain />} />
              <Route path='*' element={<NotFoundPage />} />
            </Routes>
        <Footer />
      </div>)
};

export const HomeV2 = () =>(

  <div>
    <Header />
    <Header2/>
    <Header3 />
    <Header4 />
    <SpecialMenu />
    <AboutUs />
    <Services />
    <Laurels />
    <Chef />
    <Chef2 />
    {/* the video for intro */}
    <Intro />
    <Gallery />
    <FindUs />
  </div>
)

// export default App;
const NotFoundPage = () => {

  return <div>
    Page Not Found.
    <a href={HOME_ROUTE}>Back Home</a>
  </div>
}


export const ErrorSuccessSweetAlert = ({message, type}) => {

  return <SweetAlert
    success={type==='success'} title={message.title} onConfirm={() => {}} onCancel={() => {}}>
    {message.message}

  </SweetAlert>
}